export const generateLinkCIDKey = ({ orgId, streamId, channelId, linkId }) =>
  [orgId, streamId, channelId, linkId].join('/');
